if (!customElements.get('where-to-buy-modal')) {
  class WhereToBuyModal extends HTMLElement {
    constructor() {
      super();
      this.trigger = this.querySelector('.wtb__trigger');
      this.overlay = this.querySelector('.wtb__overlay');
      this.dialog = this.querySelector('.wtb__dialog');
      this.closeBtn = this.querySelector('.wtb__close');

      this.trigger.addEventListener('click', this.open.bind(this));
      this.closeBtn.addEventListener('click', this.close.bind(this));
      this.overlay.addEventListener('click', this.close.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));
    }

    onKeydown(event) {
      if (event.code === 'Escape') this.close();
      if (event.code === 'Tab') this.trapFocus(event);
    }

    open() {
      this.overlay.hidden = false;
      this.dialog.hidden = false;
      document.body.classList.add('wtb-open');
      this.focusable = this.dialog.querySelectorAll('button, a[href]');
      this.closeBtn.focus();
    }

    close() {
      this.overlay.hidden = true;
      this.dialog.hidden = true;
      document.body.classList.remove('wtb-open');
      this.trigger.focus();
    }

    trapFocus(event) {
      if (!this.focusable || this.focusable.length === 0) return;
      const first = this.focusable[0];
      const last = this.focusable[this.focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  customElements.define('where-to-buy-modal', WhereToBuyModal);
}
